interface Props {
  width: string,
  height: string,
  fill: string
    
    }

export const CurvedRightArrow = (props:any) => {

    return  (
        <CurvedRightArrowSvg
          width={props.width}
          height={props.height}
          fill={props.fill}
        />
    )}

export const CurvedRightArrowSvg = ({
  width = '15px',
  height  = '15px',
  fill = '#4D4D4D'

}: Props ) => (
<svg className='curved-arrow' viewBox="0 0 22.58 26.06" width={width} height={height} fill={fill}>
  <path d="M11.39,5.86C5.78,2.63,0,0,0,0c-.01.01,7.3,12.79,7.3,12.79C7.3,12.79,0,26.05,0,26.06c0,0,5.58-2.4,11.17-5.62,5.7-3.29,11.41-7.39,11.41-7.4,0,0-5.51-3.89-11.19-7.16Z"/>
</svg>
)
export { CurvedRightArrowSvg as ReactComponent }
